// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* کل تب */
.custom-tabs .ant-tabs-tab {
  border-radius: 12px !important;
  overflow: hidden;
  padding: 8px 16px;
  transition: all 0.3s ease; /* افکت نرم به همه تغییرات */
}

/* تب فعال */
.custom-tabs .ant-tabs-tab-active {
  background-color: rgb(59, 130, 246) !important;
  border-radius: 12px !important;
  transform: scale(1.05); /* یکم بزرگ شدن تب فعال */
  transition: all 0.3s ease; /* افکت برای فعال شدن */
}

/* متن تب فعال */
.custom-tabs .ant-tabs-tab-active .ant-tabs-tab-btn {
  color: white !important;
}

/* تب غیرفعال */
.custom-tabs .ant-tabs-tab:not(.ant-tabs-tab-active) {
  transform: scale(1); /* تب های دیگه سایزشون نرمال باشه */
}

/* خود نوار تب */
.custom-tabs .ant-tabs-nav-wrap {
  border-radius: 8px;
  overflow: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/views/articles/css/ActiveTabs.css"],"names":[],"mappings":"AAAA,UAAU;AACV;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB,EAAE,4BAA4B;AACzD;;AAEA,YAAY;AACZ;EACE,8CAA8C;EAC9C,8BAA8B;EAC9B,sBAAsB,EAAE,yBAAyB;EACjD,yBAAyB,EAAE,uBAAuB;AACpD;;AAEA,gBAAgB;AAChB;EACE,uBAAuB;AACzB;;AAEA,eAAe;AACf;EACE,mBAAmB,EAAE,mCAAmC;AAC1D;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,gBAAgB;AAClB","sourcesContent":["/* کل تب */\n.custom-tabs .ant-tabs-tab {\n  border-radius: 12px !important;\n  overflow: hidden;\n  padding: 8px 16px;\n  transition: all 0.3s ease; /* افکت نرم به همه تغییرات */\n}\n\n/* تب فعال */\n.custom-tabs .ant-tabs-tab-active {\n  background-color: rgb(59, 130, 246) !important;\n  border-radius: 12px !important;\n  transform: scale(1.05); /* یکم بزرگ شدن تب فعال */\n  transition: all 0.3s ease; /* افکت برای فعال شدن */\n}\n\n/* متن تب فعال */\n.custom-tabs .ant-tabs-tab-active .ant-tabs-tab-btn {\n  color: white !important;\n}\n\n/* تب غیرفعال */\n.custom-tabs .ant-tabs-tab:not(.ant-tabs-tab-active) {\n  transform: scale(1); /* تب های دیگه سایزشون نرمال باشه */\n}\n\n/* خود نوار تب */\n.custom-tabs .ant-tabs-nav-wrap {\n  border-radius: 8px;\n  overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
